import React from "react";
import { Drawer, Input, Layout, Menu, Modal, Popover} from "antd";
import AisinoButtonArea from "./common/area/AisinoButtonArea";
import CacheRoute, {CacheSwitch, clearCache, dropByCacheKey, getCachingKeys} from "react-router-cache-route";
import routes from "./routing/routes";
import "../site/source/css/index.css";
import MoRenLogo from "file-loader!../site/source/images/moren_logo.png";
import XiaLa from "file-loader!../site/source/images/xiala.png";
import Logout from "file-loader!../site/source/images/logout.png";
import Profile from "file-loader!../site/source/images/profile.png";
import AccountSecurityPng from "file-loader!../site/source/images/shouquanshezhi.png";
import PasswordIcon from "file-loader!../site/source/images/password_icon.png";
import {Link, Redirect, withRouter} from "react-router-dom";
import AisinoBreadcrumb from "./routing/AisinoBreadcrumb";
import Login from "./login";
import ContactUs from "./contactUs";
import InvoiceIssuance from "./views/invoice/h5/invoiceIssuance";
import noPermission from "./noPermission";
import cookie from "react-cookies";
import * as ModelMethod from "./common/modal/AisinoModalMethod";
import store from "./store";
import {post, postSync} from "./common/utils/http";
import {connect} from 'react-redux';
import {
	arrayToJson,
	DEFAULT_LANGUAGE,
	getLanguage,
	LANGUAGE,
	LEGAL_NAME,
	LOGIN,
	sonsTree,
	USER_ID,
	getDateFormat,
	setExportLimit,
	setButtonIdFun,
	setSelectedTinListFun,
	setCancelSubmissionInterval,
	setCancelRejectLimit,
	setInvoiceSubmissionInterval,
	setPerBatchSubmissionNumber,
	setMaxInquiryDays,
	setBackupUploadedFileDeletePeriod,
	LANGUAGE_EN, LANGUAGE_ZH
} from "./source/js/common";
import menuRoutesAction from "./store/actions/menuRoutesAction";
import IndexUserImg from "./indexUserImg";
import {isEmpty} from "./common/utils/StringUtils";
import IndexHome from "./home";
import {logout} from "./store/actions";
import overTime from './common/utils/overTime'
import ModifyPassword from './modifyPassword'
import navIcon from 'file-loader!../site/source/images/nav_icon.png';
import handleMenuSearchListReload from "./store/actions/handleMenuSearchListReload";
import AisinoRow from "./baseComponent/rowAndCol/AisinoRow";
import AisinoCol from "./baseComponent/rowAndCol/AisinoCol";
import AisinoTableButton from "./common/table/AisinoTableButton";
import RightOutlined from "@ant-design/icons/es/icons/RightOutlined";
import LeftOutlined from "@ant-design/icons/es/icons/LeftOutlined";
import CheckSquareOutlined from "@ant-design/icons/es/icons/CheckSquareOutlined";
import AisinoTable from "./common/table/AisinoTable";
import Guideline from "./guideline";
import InvoiceIssuanceBill from "./views/invoice/h5/invoiceIssuanceBill";
import AccountSecurity from "./accountSecurity";
import {CheckOutlined} from "@ant-design/icons";

const indexLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/index.js');
const commonLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/common.js');
const loginLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/login.js');
const messageLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/message.js');
if(getLanguage()===LANGUAGE_ZH){
	document.title="MyInvoice2U 电子发票系统";
}
const {  Sider  } = Layout;
const { SubMenu } = Menu;
const infoP = {
	marginBottom: 0,
	lineHeight: "36px",
	borderBottom: "1px solid #eeeeee",
};

const infoPB = {
	marginBottom: 0,
	lineHeight: "36px",
	borderBottom: "none",
	alignItems: "center",
	display: "flex",
};
export let siteIndex;
class SiteIndex extends React.Component {
	constructor(props) {
		super(props);
		siteIndex = this;
		this.state = {
			collapsed: false,
			visible: false,
			showSetting: false,
			settingId: "",
			imgCodeUrl: MoRenLogo,
			faqMenuList: [],
			current: "home",
			indexGetImg: 0,
			reRoutes: [],
			menuTree: [],
			sumRoutes: [],
			dateFormatTimer: "",
			checkServiceName:"",
			regulationData: [],
			enableChatBot: false,
			enableEInvoicingMenu: false,
			visiblePopover: false,
			str: "1",
			modal1Visible: false,
			securityVisible:false,
            numberOfVisitors:"1",
            interviewTime:"",
			newerTipShow:false,
			newerTipNum:0,
			topLogo:null,
			systemNameData:null,
			customServiceMomentShow:false,
			searchAddon:"1",
			drawerVisible:false,
            h5Flag:false,
			isLogin:false,
			msgVisible:false,
			messageContent:{},
			languageLabel:indexLan.chinese
		};
		this.tinTable=React.createRef();
		// this.logout = this.logout.bind(this);
		this.initRoutes();
	}
	handleMsgCancel = e => {
		this.setState({
			msgVisible: false,
		});
	};
	handleUpgrad(){
		post("/notice/aisino/upgrade/getNewestNoticeId").then(noticeId =>{
			if(noticeId){
				post("aisino/portalIndex/getNoticeById",{
					cguid: noticeId
				}).then(dataRes=>{
					if(dataRes) {
						this.setState({
							msgVisible: true,
							messageContent: dataRes,
						});
						post("/notice/aos/notice/noticelist/setIstatus", {cguid: noticeId})
					}})
			}
		})

	}
	initRoutes(){
		for (let i = 0; i < routes.length; i++) {
			let route = routes[i];
			this.state.sumRoutes = [
				...this.state.sumRoutes,
				<CacheRoute
					key={route.path}
					breadcrumbName={route.breadcrumbName}
					exact={!!route.exact}
					path={route.path}
					component={route.component}
					cacheKey={route.path}
				/>,
			];
			if (route.children != null) {
				this.sumRoutes(route.path, route.children);
			}
		}
		const menuRouesInfoAction = menuRoutesAction(this.state.sumRoutes);
		store.dispatch(menuRouesInfoAction);
	}
	onCollapse = (collapsed) => {
		this.setState({ collapsed });
	};
	handleLogout() {
		const that = this;
		that.hide();
		ModelMethod.aisinoConfirmModal(
			indexLan.exitTheSystem,
			"",
			() => {
				post("aos/mainui/index/logout", {}).then((response) => {
					if (response === null) return;
					cookie.remove(LOGIN);
					cookie.remove(USER_ID);
					cookie.remove(LEGAL_NAME);
					cookie.remove("gridPageSizeParam");
					cookie.remove("gridSizeListParam");
					store.dispatch(logout());
					that.props.history.go(0);
					//that.props.history.push("/login");
				});
			}
		);
	}


	handleOk = () => {
		this.operationStatus(this.state.radioValue,this.state.taxCalculationValue);
	};
	handleCancel = () => {
		this.setState({showSetting: false})
	};
	onValueChanged = (e) => {
		this.setState({radioValue: e.target.value});
	};
	onTaxValueChanged = (e) => {
		this.setState({taxCalculationValue: e.target.value});
	};
	operationStatus = (e,v) => {
		var param = {};
		param["status"] = e;
		param["taxCalculationType"] = v;
		if (!isEmpty(this.state.settingId)) {
			param["id"] = this.state.settingId;
		}
		post("/invoice/aisino/setNotice/insetOrUpdateSetNotification", param).then((response) => {
			if (response != null) {
				this.setState({settingId: response})

			}
			this.setState({showSetting: false})
		});
	};
	recRoutes(upperPath, children) {
		for (let i = 0; i < children.length; i++) {
			let route = children[i];
				this.state.reRoutes = [
					...this.state.reRoutes,
					<CacheRoute
						key={upperPath + route.path}
						breadcrumbName={route.breadcrumbName}
						exact={!!route.exact}
						path={upperPath + route.path}
						component={route.component}
						cacheKey={upperPath + route.path}
					/>,
				];
			if (route.children != null) {
				let upperPathChild = upperPath + route.path;
				this.recRoutes(upperPathChild, route.children);
			}
		}
	}
	// componentWillReceiveProps(nextProps) {
	// 	if (nextProps.showMenu == true) {
	// 		this.props.foo(false)
	// 		if(!isEmpty(cookie.load(USER_ID))){
	// 			overTime()
	// 		}
	// 		post("aisino/portalIndex/getMenu").then(response => {
	// 			this.getMenu(response);
	// 		});
	// 	}
	// 	return true;
	// }
	async componentDidMount() {
		const that = this;
		//获取系统参数
		const sysParams = await post("aisino/portalIndex/sysParam");
		let language = DEFAULT_LANGUAGE;
		if(sysParams){
			this.state.isLogin=sysParams.isLogin;
			this.setState(sysParams);
			sessionStorage.setItem("databaseType",sysParams.databaseType);
			if(sysParams.language != null){
				language  = sysParams.language;
			}
			sessionStorage.setItem("displayDecimalSetting",sysParams.displayDecimalSetting);
			sessionStorage.setItem("unitPriceDisplayDecimalSetting",sysParams.unitPriceDisplayDecimalSetting);
			cookie.save("gridPageSizeParam",sysParams.gridPageSizeParam);
			cookie.save("gridSizeListParam",sysParams.gridSizeListParam);
			setExportLimit(sysParams.exportLimit);
			setCancelSubmissionInterval(sysParams.cancelSubmissionInterval);
			setInvoiceSubmissionInterval(sysParams.invoiceSubmissionInterval);
			setPerBatchSubmissionNumber(sysParams.perBatchSubmissionNumber);
			setCancelRejectLimit(sysParams.CancellationOrRejectionPeriod);
			setMaxInquiryDays(sysParams.maxInquiryDays);
			setBackupUploadedFileDeletePeriod(sysParams.backupUploadedFileDeletePeriod);

			//2024-09-18 纳税人登录后设置登录人的按钮ids
			if(sysParams.isLogin){
				setButtonIdFun(sysParams.menuIdList);
				that.getSelectedTin();
			}
		}
		//多语言初始化，默认为英文
		if(cookie.load(LANGUAGE)===undefined || cookie.load(LANGUAGE)==='undefined'){
			cookie.save(LANGUAGE,language,{path:"/"});
			window.location.reload();
		}
		if(cookie.load(LANGUAGE) === LANGUAGE_EN){
			this.setState({languageLabel:indexLan.chinese});
		}
		else{
			this.setState({languageLabel:indexLan.english});
		}
		//获取logo图片
		const logoImgRes = await post("aisino/backgroundsetting/getSideImgSetting",{"side":'000002'});
		// console.log(logoImgRes);
		if(logoImgRes!=null){
			if(logoImgRes["logoData"]!=null){
				this.setState({
					topLogo: logoImgRes["logoData"],
				});
			}else{
				this.setState({
					topLogo: null,
				});
			}
			if(logoImgRes["systemNameData"]!=null){
				this.setState({
					systemNameData: logoImgRes["systemNameData"],
				});
			}else{
				this.setState({
					systemNameData: null,
				});
			}
		}else{
			this.setState({
				topLogo: null,
				systemNameData:null
			});
		}
		if(this.props.location && (this.props.location.pathname==="/invoiceIssuance"
			|| this.props.location.pathname==="/invoiceIssuanceBill")){
		    this.state.h5Flag=true;
		    this.setState({})
			return;
		} else if (isEmpty(cookie.load(USER_ID))) {
			this.props.history.push({ pathname: "/login" });
		}else{
			//cookie是否过期  如果过期需要做登出操作
			if(!this.state.isLogin){
				getCachingKeys().forEach(item => {
					dropByCacheKey(item)
				})
				const logoutRes = post("aos/mainui/index/logout", {},false);
				if (logoutRes){
					cookie.remove(LOGIN);
					cookie.remove(USER_ID);
					cookie.remove(LEGAL_NAME);
					cookie.remove("gridPageSizeParam");
					cookie.remove("gridSizeListParam");
					store.dispatch(logout());
					this.props.history.push("/login");
				}
			}else{
				this.props.history.push({ pathname: "/home" });
				overTime()
			}
		}
		if(cookie.load(USER_ID)){
			that.handleUpgrad();
			const response = await post("aisino/portalIndex/getMenu",{},false);
			this.getMenu(response);
		}
		// //订阅登入之后刷新菜单
		store.subscribe(async () => {
			if (
				this.state.reRoutes.length===0 && cookie.load(USER_ID)
			) {
				that.handleUpgrad();
				const response = await post("aisino/portalIndex/getMenu",{},false);
				this.getMenu(response);
			}
		});
		getDateFormat();
		//增加定时器每1分钟获取时间格式放入seesion
		// this.state.dateFormatTimer = setInterval(() => {
		// 	getDateFormat();
		// }, 1000 * 60);
		// console.log("========componentDidMount===========");
	}
	//纳税人端和局端不能在同一浏览器同时登录，设置定时任务检测，统一退出
	checkServiceNameMethod(){
		post("/site/aisino/rms/user/checkServiceName",{},false).then(res=>{
			if(res != true){
				cookie.remove(LOGIN);
				cookie.remove(USER_ID);
				cookie.remove(LEGAL_NAME);
				cookie.remove("gridPageSizeParam");
				cookie.remove("gridSizeListParam");
				store.dispatch(logout());
				this.props.history.push("/login");
			}
		});
	}
	componentWillUnmount() {
		// clearInterval(this.state.dateFormatTimer);
		clearInterval(this.state.checkServiceName);
	}
	async loadFaqMenu() {
		const faqList = await post("aisino/faqLevel/getFaqLevelList").then((response) => {
			if (response != null) {
				let tree = arrayToJson(response);
				let newTree = sonsTree(tree, 0);
				this.setState({ faqMenuList: newTree });
			}
		});
		const res = await post("aisino/policyLevel/getRegulationLevelList");
		let regulationTree = arrayToJson(res);
		let newRegulationTree = sonsTree(regulationTree, 0);
		// console.log("regulationTree",regulationTree);
		// console.log("newRegulationTree",newRegulationTree);
		this.setState({ regulationData: newRegulationTree });
	}
	handleClick = (e) => {
		this.setState({
			current: e.key,
		});
	};
	getMenu(response) {
		const haveList = [];
		if (response.menuTree.length == 0) { //有的子账户会返回一个空的列表 所以需要判断，渲染不需要权限的路由
			routes.forEach(item=>{
				let foo = (data)=>{
					if (data.login === false) {
						haveList.push(item);
					}
					if (data.ignoreAuthority === true) {
						haveList.push(item);
					}
					if(data.children){
						foo(data.children)
						return false
					}
				}
				foo(item)
			})
		}else{
			// ======================================================================================
			for (let i = 0; i < response.menuTree.length; i++) {
				if (response.menuTree[i].children != undefined) {
					let secondaryMenulist = response.menuTree[i].children;
					for (let j = 0; j < secondaryMenulist.length; j++) {
						for (let k= 0; k < routes.length; k++) {
							let route = routes[k];
							const have = haveList.find((item) => item.path == route.path);
							if (have != undefined) {
								continue;
							}
							if (route.login === false) {
								haveList.push(route);
								continue;
							}
							if (secondaryMenulist[j].service_name+secondaryMenulist[j].curl == route.sitePath) {
								secondaryMenulist[j].sitePath = route.path;
								haveList.push(route);
								continue;
							}
							if (route.ignoreAuthority === true) {
								haveList.push(route);
							}
						}
						if (secondaryMenulist[j].sitePath == undefined) {
							secondaryMenulist[j].sitePath = "/noPermission";
						}
					}
				}
			}
		}

		this.setState({ menuTree: response.menuTree });
		this.state.reRoutes = [];
		for (let i = 0; i < haveList.length; i++) {
			let route = haveList[i];
			this.state.reRoutes = [
				...this.state.reRoutes,
				<CacheRoute
					key={route.path}
					breadcrumbName={route.breadcrumbName}
					exact={!!route.exact}
					path={route.path}
					component={route.component}
					cacheKey={route.path}
				/>,
			];
			if (route.children != null) {
				this.recRoutes(route.path, route.children);
			}
		}
	}
	// async componentWillMount() {
	// 	for (let i = 0; i < routes.length; i++) {
	// 		let route = routes[i];
	// 		this.state.sumRoutes = [
	// 			...this.state.sumRoutes,
	// 			<CacheRoute
	// 				key={route.path}
	// 				breadcrumbName={route.breadcrumbName}
	// 				exact={!!route.exact}
	// 				path={route.path}
	// 				component={route.component}
	// 				cacheKey={route.path}
	// 			/>,
	// 		];
	// 		if (route.children != null) {
	// 			this.sumRoutes(route.path, route.children);
	// 		}
	// 	}
	// 	const menuRouesInfoAction = menuRoutesAction(this.state.sumRoutes);
	// 	store.dispatch(menuRouesInfoAction);
	// 	// this.loadFaqMenu();
	// 	const response = await post("aisino/portalIndex/getMenu");
	// 	this.getMenu(response);
	// }
	sumRoutes(upperPath, children) {
		for (let i = 0; i < children.length; i++) {
			let route = children[i];
			this.state.sumRoutes = [
				...this.state.sumRoutes,
				<CacheRoute
					key={upperPath + route.path}
					breadcrumbName={route.breadcrumbName}
					exact={!!route.exact}
					path={upperPath + route.path}
					component={route.component}
					cacheKey={upperPath + route.path}
				/>,
			];
			if (route.children != null) {
				let upperPathChild = upperPath + route.path;
				this.sumRoutes(upperPathChild, route.children);
			}
		}
	}
	setFAQSid(val, e) {
		getCachingKeys().forEach(item => {
			dropByCacheKey(item)
		})
		if (e.target.id == "b") {
			sessionStorage.setItem("FAQs", val)
		} else {
			sessionStorage.setItem("FAQs", val)
		}
	}
	setPolicyid(val, e) {
		getCachingKeys().forEach(item => {
			dropByCacheKey(item)
		})
		if (e.target.id == "b") {
			sessionStorage.setItem("policy", val)
		} else {
			sessionStorage.setItem("policy", val)
		}
		let w= window.innerWidth || document.body.clientWidth;
		if(w <= 991){
			this.setState({ collapsed:true });
		}
	}
	handleHome() {
		getCachingKeys().forEach(item => {
			dropByCacheKey(item)
		})
		if (sessionStorage.getItem("verifyLogin") === "1") {
			this.props.history.push("/")
		} else {
			this.props.history.push("/")
			cookie.remove(LOGIN);
			cookie.remove(USER_ID);
			cookie.remove(LEGAL_NAME);
			cookie.remove("gridPageSizeParam");
			cookie.remove("gridSizeListParam");
			this.props.foo(true)
			sessionStorage.setItem("aogin", "0")
		}
		let w= window.innerWidth || document.body.clientWidth;
		if(w <= 991){
			this.setState({ collapsed:true });
		}
	}
	handleClearCache() {
		getCachingKeys().forEach(item => {
			dropByCacheKey(item)
		})
		let w= window.innerWidth || document.body.clientWidth;
		if(w <= 991){
			this.setState({ collapsed:true });
		}
	}
	menuClick(path) {
		clearCache();
		this.props.history.push({ pathname: path, query: {sj:Math.random()}});
		let w= window.innerWidth || document.body.clientWidth;
        if(w <= 991){
            this.setState({ collapsed:true });
        }
	}
	async searchPolicyOrFaqs(value) {
		if (this.props.history.location.pathname !== "/menuSearchList") {
			this.props.history.push({ pathname: "/menuSearchList", state: { pageData: value } });
			store.dispatch(handleMenuSearchListReload(value));
		} else {
			store.dispatch(handleMenuSearchListReload(value));
		}
		let w= window.innerWidth || document.body.clientWidth;
		if(w <= 991){
			this.setState({ collapsed:true });
		}
	}
	searchAddon(value){
		this.state.searchAddon = value;
		this.setState({});
	}
	hide = () => {
		this.setState({
			visiblePopover: false,
		});
		let w= window.innerWidth || document.body.clientWidth;
		if(w <= 991){
			this.setState({ collapsed:true });
		}
	};
	handleVisibleChange = visiblePopover => {
		this.setState({ visiblePopover });
	};
	setModal1Visible(modal1Visible) {
		this.hide();
		this.setState({ modal1Visible });
	}
	handleClose() {
		this.setState({ modal1Visible: false });
		let w= window.innerWidth || document.body.clientWidth;
		if(w <= 991){
			this.setState({ collapsed:true });
		}
	}
	setSecurityVisible(securityVisible) {
		this.hide();
		this.setState({ securityVisible });
	}
	handleSecurityClose() {
		this.setState({ securityVisible: false});

		let w= window.innerWidth || document.body.clientWidth;
		if(w <= 991){
			this.setState({ collapsed:true });
		}
	}
	getFaqsMenuNodes = (menuList) => {
		return menuList.map(item => {
			if (!item.children) {
				return (
					<Menu.Item id="b"
						key={item.id}>
						<Link
							onClick={this.setFAQSid.bind(this, item.id)}
							to={{ pathname: "/faq_list", faqLevelId: item.id }}>
							{item.faqLevelName}
						</Link>
					</Menu.Item>
				);
			}  else {
				return (<SubMenu
					key={item.id}
					title={
						<Link
							onClick={this.setFAQSid.bind(this, item.id)}
							to={{
								pathname: "/faq_list",
								faqLevelId: item.id,
							}}>
							{item.faqLevelName}
						</Link>
					}>
					{
						this.getFaqsMenuNodes(item.children)
					}
				</SubMenu>);
			}
		});
	}
	getPolicyMenuNodes = (menuList) => {
		return menuList.map(item => {
			if (!item.children) {
				return (
					<Menu.Item  id="b"
							    key={item.id}>
						<Link onClick={this.setPolicyid.bind(this, item.id)}
							to={{
								pathname: "/policy_list",
								regulationLevelId: item.id,
							}}>
							{item.regulationLevelName}
						</Link>
					</Menu.Item>
				);
			}  else {
				return (<SubMenu
					key={item.id}
					title={
						<Link
							onClick={this.setPolicyid.bind(this, item.id)}
							to={{
								pathname: "/policy_list",
								regulationLevelId: item.id,
							}}>
							{item.regulationLevelName}
						</Link>
					}>
					{
						this.getPolicyMenuNodes(item.children)
					}
				</SubMenu>);
			}
		});
	}

	//多语言切换
	languageChange(){
		let e = "";
		if(this.state.languageLabel==indexLan.chinese){
			e = LANGUAGE_ZH;
		}
		else{
			e = LANGUAGE_EN;
		}
		cookie.remove(LANGUAGE,{path:"/"});
		cookie.save(LANGUAGE,e,{path:"/"});
		window.location.reload();
	}

	drawerOkBtnClick(){
		const rows = this.tinTable.current.getSelectedRows();
		let tinList = rows.map((row)=>  row.tin);
		postSync("aisino/portalIndex/saveSelectedTin",{tinList:tinList}).then(res=>{
			this.setState({
				drawerVisible:false
			})
			//2024-09-26 这里把选中的tin存起来，方便其他页面使用
			setSelectedTinListFun(tinList);
		})
	}
	getSelectedTin(){
		const that = this;
		const tinTable = that.tinTable.current;
		postSync("aisino/portalIndex/getSelectedTin").then(res=>{
			if(res){
				const rows = tinTable.findRows(function(row){
					if(res.includes(row.tin)){
						return true;
					}
					return false;
				})
				tinTable.selectRows(rows);

				//2024-09-26 这里把选中的tin存起来，方便其他页面使用
				setSelectedTinListFun(res);
			}
		})
	}
	showDrawer(){
		const that = this;
		if(!that.state.drawerVisible){
			that.tinTable.current.loadTableData(null,null,null,function(){
				that.getSelectedTin();
			});
		}
		this.setState({
			drawerVisible:!this.state.drawerVisible
		})
	}
	render() {
		const {newerTipShow,newerTipNum,searchAddon,drawerVisible,h5Flag}= this.state;
		const { Search } = Input;
		const isSiderShow = this.props.location.pathname!=="/policy_list"
						  & this.props.location.pathname!=="/faq_list"
						  & this.props.location.pathname!=="/userManual"
						  & this.props.location.pathname!=="/performance"
						  & this.props.location.pathname!=="/siteMap"
						  & this.props.location.pathname!=="/contactUs"
			              & this.props.location.pathname!=="/guideline"
						  & this.props.location.pathname!=="/faq_list/faq_detail"
						  & this.props.location.pathname!=="/policy_list/policy_detail"
						  & this.props.location.pathname!=="/searchList"
			              & this.props.location.pathname!=="/menuSearchList"
						  & this.props.location.pathname!=="/searchList/faq_detail"
			              & this.props.location.pathname!=="/invoiceIssuance"
			              & this.props.location.pathname!=="/invoiceIssuanceBill"
		const languageContent=(
			<div style={{marginBottom: 0,lineHeight: "36px",width:"70px",height:"100%"}}>
				<table style={{border:"0px",}}>
					<tr>
						<td>{cookie.load(LANGUAGE)==LANGUAGE_EN?<CheckOutlined/>:<></>}</td>
						<td><Link style={{color: "#666",float:"right"}} onClick={(e)=>this.languageChange(LANGUAGE_EN)}>{indexLan.english}</Link></td>
					</tr>
					<tr>
						<td>{cookie.load(LANGUAGE)==LANGUAGE_ZH?<CheckOutlined/>:<></>}</td>
						<td><Link style={{color: "#666",float:"right"}} onClick={(e)=>this.languageChange(LANGUAGE_ZH)}>{indexLan.chinese}</Link></td>
					</tr>
				</table>
			</div>
		);

		return (
			<div>
				<div
					hidden={!newerTipShow}
					style={{
						display:'flex',
						position:'fixed',
						top:'0px',
						left:'0px',
						zIndex:1000,
						height:'100%',
						width:'100%',
						background:'rgba(0,0,0,0.4)',
						textAlign:'center',
						justifyContent:'space-around',
						alignItems:'center'
					}}
					>
				</div>
				<Layout style={{paddingBottom: "10px",backgroundColor: 'transparent'}} >
					<AisinoRow style={{ padding: 0, height: !isEmpty(cookie.load(USER_ID))&&!h5Flag ? 75 : 30 }}>
						<AisinoCol span={24}>
							<AisinoRow style={{ height: 30, backgroundColor: "#282828" }}>
								<AisinoCol span={24}>
									<ul className="contact">
										<li onClick={() => { this.props.history.push("/guideline") }}><a>{indexLan.guideline}</a></li>
										<li onClick={() => { this.props.history.push("/contactUs") }}><a>{indexLan.contactUs}</a></li>
										{/*<li>*/}
										{/*	<Popover className="popoverIE9" content={languageContent} placement="bottom" trigger="hover">*/}
										{/*		<a>{indexLan.language}</a>*/}
										{/*	</Popover>*/}
										{/*</li>*/}
										<li><a onClick={(e)=>this.languageChange()}>{this.state.languageLabel}</a></li>
									</ul>
								</AisinoCol>
							</AisinoRow>
							<AisinoRow style={{height:!isEmpty(cookie.load(USER_ID))&&!h5Flag ? 45 :0, backgroundColor: "rgb(245, 251, 255)" }}>
								<AisinoCol span={24}>
									{!isEmpty(cookie.load(USER_ID))&&!h5Flag ?
									<AisinoRow justify="end">
										<AisinoCol lg={6} md={8} sm={12} xs={15} style={{paddingTop:"6px"}}>
											<Search
													placeholder={indexLan.searchFunction}
													onSearch={(value) => this.searchPolicyOrFaqs(value)}
											/>
										</AisinoCol>
										<AisinoCol lg={2} md={3} sm={4} xs={5}>
											<Popover
													 className="popoverIE9"
													 placement='bottom'
													 visible={this.state.visiblePopover}
													 onVisibleChange={this.handleVisibleChange}
													 content={
														 <div>
															 <p style={infoP} title={cookie.load(LEGAL_NAME)}>{cookie.load(LEGAL_NAME)&&cookie.load(LEGAL_NAME).length>20?cookie.load(LEGAL_NAME).substr(0,20)+"...":cookie.load(LEGAL_NAME)}</p>
															 <div
																 style={{
																	 marginBottom: 0,
																	 lineHeight: "36px",
																	 borderBottom: "1px solid #eeeeee",
																 }}>
																 <img src={Profile} style={{ width: 16, height: 16 }} />
																 <Link
																	 onClick={this.hide}
																	 to={{ pathname: "/myProfile" }}
																	 style={{ color: "#666", marginLeft: "8px" }}>
																	 {indexLan.viewProfile}
																 </Link>
															 </div>
															 <div style={infoP}>
																 <img src={PasswordIcon} style={{width: 16, height: 16}}/>
																 <a
																	 style={{color: "#666", marginLeft: "8px"}}
																	 onClick={() => this.setModal1Visible(true)}>
																	 {loginLan.modifyPassword}
																 </a>
															 </div>
															 <div style={infoP}>
																 <img src={AccountSecurityPng} style={{width: 16, height: 16}}/>
																 <a
																	 style={{color: "#666", marginLeft: "8px"}}
																	 onClick={() => this.setSecurityVisible(true)}>
																	 {loginLan.accountSecurity}
																 </a>
															 </div>
															 <div style={infoPB}>
																 <img src={Logout} style={{ width: 16, height: 16 }} />
																 <a
																	 style={{ color: "#666", marginLeft: "8px" }}
																	 onClick={() => this.handleLogout()}>
																	 {indexLan.logout}
																 </a>
															 </div>
														 </div>
													 }
													 trigger='hover'>
												<span style={{pointerEvents:newerTipNum===1?'none':'',position:newerTipNum===1?'sticky':'static' ,zIndex:newerTipNum===1?1001:0}}>
													{!isEmpty(cookie.load(USER_ID)) ? <IndexUserImg /> : ""}
													<img
														src={XiaLa}
														style={{
															width: 18,
															height: 18,
															marginLeft: 8,
															display: cookie.load(USER_ID) != null ? "" : "none",
														}}
													/>
												</span>
											</Popover>
										</AisinoCol>
									</AisinoRow>:""}
								</AisinoCol>
							</AisinoRow>
						</AisinoCol>
						<Modal
							title={loginLan.accountSecurity}
							style={{ top: "15%" }}
							visible={this.state.securityVisible}
							onOk={() => this.setSecurityVisible(false)}
							onCancel={() => this.setSecurityVisible(false)}
							footer={null}
							width={750}
							maskClosable={false}
							destroyOnClose={true}
						>
							<AccountSecurity handleSecurityClose={this.handleSecurityClose.bind(this)} {...this.props} />
						</Modal>
						<Modal
							title={loginLan.modifyPassword}
							style={{ top: "15%" }}
							visible={this.state.modal1Visible}
							onOk={() => this.setModal1Visible(false)}
							onCancel={() => this.setModal1Visible(false)}
							maskClosable={false}
							// okText="Submit"
							// cancelText="Cancel"
							footer={null}
						>
							<ModifyPassword home={true} handleClose={this.handleClose.bind(this)} {...this.props} />
						</Modal>
					</AisinoRow>
					<div>
						{!isEmpty(cookie.load(USER_ID))&&!h5Flag?
							<AisinoTableButton type="primary" icon={drawerVisible?<RightOutlined />:<LeftOutlined />} onClick={()=>this.showDrawer()} style={{position:'absolute',top:80,height:"100px",width:"30px",right:drawerVisible?350:0,zIndex:1001}}/>
							:""}
						<Layout style={{backgroundColor: 'transparent'}}>
							{/* {console.log(this.props.isSiderShow,"1222222")} */}
							{!isEmpty(cookie.load(USER_ID)) && isSiderShow?
								<Sider
									style={{height:"1%",borderBottom:"1px #f0f0f0 solid",pointerEvents:newerTipNum===3?'none':'',position:newerTipNum===3?'sticky':'' ,zIndex:newerTipNum===3?1001:900}}
									width={270}
									className={"leftSider"}
									breakpoint='lg'
									collapsedWidth='0'
									collapsed={this.state.collapsed}
									onCollapse={this.onCollapse}>
									<div className='logo1' style={{cursor: "pointer"}} onClick={()=>this.handleHome()}>ICS</div>
									<Menu theme='light' mode='vertical'>
										{this.state.menuTree.map((item) => {
											if(item.cname=='API Request URL'){
												return;
											}
											if(item.cguid=='483503119299500245'){
												return;
											}
											return (
												<SubMenu
													style={{borderBottom:"1px #eee solid"}}
													key={item.cguid}
													title={
														<span>
															{/* <ProfileOutlined />    左侧导航的图标暂时不用  */}
															<span style={{ fontWeight: "bold",fontSize:"13px" }}>{item.cname}</span>
														</span>
													}>
													{item.children &&
														item.children.map((childItem) => (
															<Menu.Item key={childItem.cguid}>
																<img src={navIcon}  style={{height:"12px",marginTop:"-2px",marginRight:"5px"}}   />
																<span>{childItem.cname}</span>
																<a onClick={() => { this.menuClick(childItem.sitePath) }} ></a>
															</Menu.Item>
														))}
												</SubMenu>
											);
										})}
									</Menu>
								</Sider>: ""}
							<Layout className='site-layout' style={{background: "rgba(0,0,0,0)",minHeight:"60vh"}}>
								{!isEmpty(cookie.load(USER_ID))&&!h5Flag?
									<div style={{pointerEvents:newerTipNum===4?'none':'',position:newerTipNum===4?'sticky':'static' ,zIndex:newerTipNum===4?1001:null}}>
										<AisinoBreadcrumb />
									</div>:<></>
								}

								<div
									className={"ant-layout-div"}
									style={{ margin: "0 10px" ,minHeight: window.innerHeight-182 }}
									id='mainDiv'>
									<CacheSwitch>
										{this.state.reRoutes}
										{!isEmpty(cookie.load(USER_ID)) ? (
											[
												<CacheRoute key="1" exact path='/home' cacheKey={"/home"} render={props=><IndexHome {...props} indexPage={this}/>}/>,
												<Redirect key="2" exact path='/' to='/home' />,
												<CacheRoute key="7" exact path='/invoiceIssuance' component={InvoiceIssuance} cacheKey={"/invoiceIssuance"} />,
												<CacheRoute key="8" exact path='/invoiceIssuanceBill' component={InvoiceIssuanceBill} cacheKey={"/invoiceIssuanceBill"} />,
												<CacheRoute key="3" exact path='*' component={noPermission} />,
											].map((item) => item)
										) : [
											<CacheRoute key="4" exact path='/login' component={Login} cacheKey={"/login"} />,
											<CacheRoute key="5" exact path='/invoiceIssuance' component={InvoiceIssuance} cacheKey={"/invoiceIssuance"} />,
											<CacheRoute key="8" exact path='/invoiceIssuanceBill' component={InvoiceIssuanceBill} cacheKey={"/invoiceIssuanceBill"} />,
											<CacheRoute key="6" exact path='/contactUs' component={ContactUs} cacheKey={"/login"} />,
											<CacheRoute key="7" exact path='/guideline' component={Guideline} cacheKey={"/login"} />,
											<Redirect key="7" exact path='*' to='/login' />
										].map((item) => item)
										}
									</CacheSwitch>
								</div>
							</Layout>
						</Layout>
					</div>
				</Layout>
				{/*<Footer*/}
					{/*className={"print_hide"}*/}
					{/*style={{ textAlign:"center",backgroundImage:`url(${foot_bck})`,marginTop:"10px" ,position:"fixed",bottom:"0",height:"40px"}}>*/}
				{/*</Footer>*/}

				<Drawer
					title={indexLan.myCompany}
					placement="right"
					forceRender={true}
					closable={true}
					visible={drawerVisible}
					getContainer={false}
					width={"350"}
					onClose={()=>this.showDrawer()}
				>
					<AisinoTable ref={this.tinTable}
								 columns={[
									 {title: commonLan.all.label,dataIndex:'tin',width: 200,render:(text,record)=>{
											 return  <div style={{ whiteSpace: 'normal' }}>{record.tin+"("+record.name+")"}</div>;
										 }}
								 ]}
								 loadUrl={"aisino/myProfile/getMyProfileList"}
								 rowSelection={{type:"checkbox"}}
								 pagination={false}
								 scroll={{}}
					/>
					<span>{commonLan.drawerTip}</span>
					<div className="pageBottomButtonBg">
						<AisinoButtonArea buttonModules={[
							<AisinoTableButton label = {commonLan.okButton.label} icon={<CheckSquareOutlined/>}  onClick={()=>this.drawerOkBtnClick()}/>
						]} style={{justifyContent: "center"}}/>
					</div>
				</Drawer>

				<Modal
					className="messageConversation"
					title={messageLan.messageConversation.label}
					width={1280}
					style={{ top: 30 }}
					footer={null}
					maskClosable={false}
					bodyStyle={{padding:"0 50px",height:"650px",overflow:"auto"}}
					maskStyle={{ background: "rgba(255,255,255,0.7)" }}
					visible={this.state.msgVisible}
					onCancel={this.handleMsgCancel}
				>
					<div style={{display:"inline-block"}} dangerouslySetInnerHTML={{ __html: this.state.messageContent.content }} />
				</Modal>
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	return {
		showMenu: state.showMenu
	}
}
const mapDispathToProps = {
	foo: (data) => {
		return {
			type: "showMenu",
			payload: data
		}
	}
}
export default withRouter(connect(mapStateToProps, mapDispathToProps)(SiteIndex))
